import { fixPhotoUrl } from '../firebase';
import { apiClient } from './apiClient';

export const membersApi = {
  getMe: async (): Promise<{ message: string; memberId: string; user: string; timestamp: string; exclusiveContent: string }> => {
    return apiClient.get('/members/me');
  },
  
  ping: async (): Promise<{ message: string; time: string }> => {
    return apiClient.get('/members/ping');
  },

  getFollowing: async (memberId: string): Promise<any[]> => {
    try {
      const data = await apiClient.get<any[]>(`/profiles/${memberId}/following`);
      return data.map((f: any) => ({
        ...f,
        photoUrl: fixPhotoUrl(f.photoUrl)
      }));
    } catch (e) {
      console.error('[membersApi] getFollowing failed:', e);
      return [];
    }
  },

  followMember: async (memberId: string): Promise<{ success: boolean; message?: string }> => {
    try {
      await apiClient.post(`/profiles/${memberId}/follow`);
      return { success: true };
    } catch (e: any) {
      return { success: false, message: e.message || String(e) };
    }
  },

  unfollowMember: async (memberId: string): Promise<{ success: boolean; message?: string }> => {
    try {
      await apiClient.delete(`/profiles/${memberId}/follow`);
      return { success: true };
    } catch (e: any) {
      return { success: false, message: e.message || String(e) };
    }
  },

  getDirectory: async (): Promise<any[]> => {
    try {
      const data = await apiClient.get<any[]>('/profiles/directory');
      return data.map((f: any) => ({
        ...f,
        photoUrl: fixPhotoUrl(f.photoUrl)
      }));
    } catch (e) {
      console.error('[membersApi] getDirectory failed:', e);
      return [];
    }
  }
};
